import AnnouncementFeed from '../components/AnnouncementFeed';

const ANNOUNCEMENT_ICON = 'M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z';

export default function Announcements() {
  return (
    <AnnouncementFeed
      title="Duyurular"
      description="Son 30 günde size iletilen duyurular"
      emptyTitle="Henüz duyuru bulunmuyor"
      emptyText="Yeni duyurular yayınlandığında burada görüntülenecektir. Bilgilendirmeleri kaçırmamak için düzenli olarak kontrol edin."
      errorTitle="Duyurular yüklenemedi"
      iconPath={ANNOUNCEMENT_ICON}
    />
  );
}
